import { toastr } from "react-redux-toastr";

// Imports
import { doRequest } from "../../modules/request";

export const RECEIVE_EXTRACAO = "RECEIVE_EXTRACAO";
export const CLEAN_EXTRACAO = "CLEAN_EXTRACAO";
export const RECEIVE_EXTRACAO_DATA = "RECEIVE_EXTRACAO_DATA";

export const receiveExtracao = (payload) => ({
  type: RECEIVE_EXTRACAO,
  payload: payload,
});

export const cleanExtracao = (payload) => ({
  type: CLEAN_EXTRACAO,
  payload: payload,
});

export const receiveExtracaoData = (payload) => ({
  type: RECEIVE_EXTRACAO_DATA,
  payload: payload.arrExtracoes,
});

export const recuperaExtracao =
  (ParamExtracao, callback) => (dispatch, getState) => {
    const params = {
      url: "/Draw",
      method: "POST",
      data: ParamExtracao,
    };

    return doRequest(params)
      .then((response) => {
        if (response.intCodigoRetorno > 0) {
          toastr.error("Atenção", response.strErrorMessage);
          dispatch(
            receiveExtracao({
              extracaoJBWeb: undefined,
            })
          );
        } else {
          dispatch(receiveExtracao(response));
        }
        callback();
      })
      .catch((error) => {
        toastr.error("Houve um erro ao buscar extrações.", error.message);
        callback();
      });
  };

export const recuperaExtracaoByData =
  (ParamExtracao, callback) => (dispatch, getState) => {
    const params = {
      url: "/GetExtracaoByData",
      method: "POST",
      data: ParamExtracao,
    };

    return doRequest(params)
      .then((response) => {
        if (response.intCodigoRetorno > 0) {
          toastr.error("Atenção", response.strErrorMessage);
          dispatch(
            receiveExtracaoData({
              extracaoDoDia: undefined,
            })
          );
        } else {
          dispatch(receiveExtracaoData(response));
        }
        callback();
      })
      .catch((error) => {
        toastr.error("Houve um erro ao buscar extrações.", error.message);
        callback();
      });
  };



// WEBPACK FOOTER //
// ./src/reducers/relatorios/extracoesActions.js